var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217 123.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "talk_start") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.82,122.67H92.28A1.21,1.21,0,0,1,91,121.53v-3.86h2.82L95,121.35a.94.94,0,0,1-.2.91A1.23,1.23,0,0,1,93.82,122.67Z",
    fill: "#605d82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.22,93.67A13.22,13.22,0,0,1,26,80.44V51.89A13.22,13.22,0,0,1,39.22,38.67H156.78A13.22,13.22,0,0,1,170,51.89V80.44a13.22,13.22,0,0,1-13.22,13.23Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.64,107.67A13.64,13.64,0,0,1,11,94V15.3A13.64,13.64,0,0,1,24.64,1.67H193.36A13.64,13.64,0,0,1,207,15.3V94a13.64,13.64,0,0,1-13.64,13.64Z",
    fill: "none",
    stroke: "#e6e6e6",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,8.67H206",
    fill: "none",
    stroke: "#9b9ba8",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,21.67H206",
    fill: "none",
    stroke: "#9b9ba8",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,7.17a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,13,7.17Z",
    fill: "#f86b75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,7.17a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,19,7.17Z",
    fill: "#fad375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,7.17a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,25,7.17Z",
    fill: "#8bcc55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,7.17a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,13,7.17Z",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,7.17a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,20,7.17Z",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,7.17a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,26,7.17Z",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,16.17a3.5,3.5,0,1,1,3.5,3.5A3.5,3.5,0,0,1,53,16.17Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,15.17a3.5,3.5,0,0,1,7,0h0a3.5,3.5,0,1,1-7,0Z",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,19.67a2,2,0,0,1-2-2v-1a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2Z",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,19.67a2,2,0,0,1-2-2v-1a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2Z",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,17.67a2,2,0,0,1-2-2v-1a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2Z",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,17.67a2,2,0,0,1-2-2v-1a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2Z",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,89.67a16,16,0,0,1-16-16v-23a16,16,0,0,1,16-16H162a16,16,0,0,1,16,16v23a16,16,0,0,1-16,16Z",
    fill: "none",
    stroke: "#9b9ba8",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,63.49l-1.9,1.32-6.33-5.19V57.27Zm1,12.18a13.86,13.86,0,0,0-1.33-25A13.6,13.6,0,0,0,87,53.34l15.78,22.33Z",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,65.17a14,14,0,1,1,14,14.5A14.26,14.26,0,0,1,79,65.17Z",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,89.82s-2.6,8.6-2.71,12.36-.57,9.78-.23,11.29S87.48,118,87.48,118s2.15-2.47,2.94-1.07c0,0-.11-2.91-.68-3.77,0,0,.23-4.51.23-6.12s2.82-9,3-9.14.9,2,.34,6.77-1,13-1,13.87,1.36,2.58,2.26,2,1.47-5.16,1.47-5.16.79-9.67,1.24-10.75,2.83-13.44,1-14.4S89.06,89.82,89.06,89.82Z",
    fill: "#46455b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,117.63a19.79,19.79,0,0,0-.55,2.87c0,.6.44,1.69-1.43,2.08s-1.55-.64-1.84-1.24l0,0c-.33-.59.44-3.66.55-3.66a10.36,10.36,0,0,0,1-1.43,1.16,1.16,0,0,1,.84-.52,1.24,1.24,0,0,1,1,.27,1.57,1.57,0,0,1,.55,1.17A1.79,1.79,0,0,1,89.93,117.63Z",
    fill: "#605d82"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.93,117.52a20.36,20.36,0,0,0-.56,2.93c0,.61.45,1.72-1.47,2.13s-1.6-.65-1.9-1.27c.32-.75,1.11-2.38,1.67-3.79.49-1.25,1.71-.84,2.33-.53A1.88,1.88,0,0,1,90.93,117.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91,70.17a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,91,70.17Z",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.33,69.71,91,73.9l4,.77s-.44-3.69-.11-4.45S91.33,69.71,91.33,69.71Z",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.17,73.81s-3.23-.32-3.44,0a1.83,1.83,0,0,0-.22.86s-1.29.54-1.5.32-.43-.86-1.08-.64S87,78.44,87,78.44s.32-1.19.86,3.33.43,7.32.54,7.64-.54,2.26,3.33,2.26,6.66-.22,6.66-1-.65-4,0-6.35c.52-1.87,1-3.73,1.61-5.59l-1.29-4.2s-1.29-.32-1.61.22-1.18.43-1.18.43S95.81,73.92,95.17,73.81Z",
    fill: "#605d82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,75.73l-2.87-1.16S79.74,70.74,80,67.34c0,0-1.84-1.59-2,.11s.46,5.52,1.84,6.8,6.08,5.31,6.77,5.41S88,75.73,88,75.73Z",
    fill: "#605d82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.33,64.67s-2.78-5.2-.29-5a1.87,1.87,0,0,1,1.9,2.4v2.6Z",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,75.73l2.87-1.16s5.39-3.83,5.16-7.23c0,0,1.84-1.59,2,.11s-.46,5.52-1.84,6.8-6.08,5.31-6.77,5.41S98,75.73,98,75.73Z",
    fill: "#605d82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,64.67s2.78-5.2.29-5a1.87,1.87,0,0,0-1.9,2.4v2.6Z",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.14,68.5l.3-.19s-1.92-1-2.73-.47a5.39,5.39,0,0,0-1.21,1.23c-.2.19-.71,1.24-.4,1.62s.2.45.4.8-.35,1.71,1.19,2.11,2.75-1.3,3-1.68S95.55,69,94.14,68.5Z",
    fill: "#46455b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,98.67c0,12.16,7.6,22,17,22",
    fill: "#46455b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,119.67c0-12.16,8.05-22,18-22",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,99.67c0,11.6,4.92,21,11,21",
    fill: "#f6933e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,120.67c0-16,9.84-29,22-29",
    fill: "#46455b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,120.1s2.42-.09,3.15-.65,3.72-1.25,3.9-.34,3.63,4.53.9,4.56-6.34-.47-7.07-1-.88-2.62-.88-2.62Z",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,123.31c-2.73,0-6.34-.52-7.07-1.06-.55-.42-.77-1.9-.85-2.58H192s.15,2.39.88,2.93,4.34,1.09,7.07,1.07c.79,0,1.06-.36,1.05-.86C200.89,123.11,200.59,123.31,200,123.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66,122.67h47",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,122.67h16",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkStart);
export default __webpack_public_path__ + "static/media/talk_start.5f4a0fd349c30842a02550d1f5baae97.svg";
export { ForwardRef as ReactComponent };